import { configureStore } from "@reduxjs/toolkit";
import workshopsReducer from "./workshops/workshopSlice";
import authenticationReducer from "./authentication/authenticationSlice";
import casesReducer from "./cases/casesSlice";
import modalReducer from "./modal/modalSlice";
import contractReducer from "./contract/contractSlice"
import customersReducer from "./customers/customersSlice";
import documentationTemplatesReducer from "./documentationTemplates/documentationTemplatesSlice";
import vehiclesReducer from "./vehicles/vehiclesSlice";
import templatesReducer from "./templates/templatesSlice";
import taxonomiesReducer from "./taxonomies/taxonomySlice"
import caseStatesReducer from "./caseStates/casesStatesSlice"
import entryChannelsReducer from "./entryChannels/entryChannelsSlice"
import appStateReducer from "./appState/appStateSlice"
import callsReducer from "./calls/callsSlice"
import itvsReducer from "./itvs/itvsSlice"
import provincesReducer from "./provinces/provinceSlice"
import workshopSearchReducer from "./workshopSearch/workshopSearchSlice"
import worshopTypesReducer from "./workshopTypes/workshopTypesSlice"
import currentCaseReducer from "./currentCase/currentCaseSlice"
import ActionResolutionsReducer from "./actionResolutions/ActionResolutionsSlice";
import workshopAppointmentTemplatesReducer from "./workshopAppointmentTemplates/workshopAppointmentTemplatesSlice";
import documentationRequestTemplatesReducer from "./documentationRequestTemplates/documentationRequestTemplatesSlice";
import taxonomyTemplates from "./factoryProcessTemplates/factoryProcessSlice"
import factoryCasesReducer from "./factoryCases/factoryCasesSlice";
import factoryProvincesReducer from "./factoryProvinces/factoryProvinceSlice"
import factoryCitiesReducer from "./factoryCities/factoryCitySlice";
import factoryOfficesReducer from "./factoryOffices/factoryOfficesSlice";
import factoryRentTypesReducer from "./factoryRentTypes/factoryRentTypeSlice";
import factoryChannelsReducer from "./factoryChannels/factoryChannelsSlice";
import factoryCategoriesReducer from "./factoryCategories/factoryCategoriesSlice"
import factoryTypesReducer from "./factoryTypes/factoryTypesSlice"
import factoryRatesReducer from "./factoryRates/factoryRatesSlice"
import factoryBranchesReducer from "./factoryBranches/factoryBranchesSlice"
import factoryITVBondReducer from "./factoryItvBond/factoryITVBondSlice";
import factoryBagGroupsReducer from "./factoryBagGroups/factoryBagGroupsSlice";
import caseFormsReducer from "./caseForms/caseFormSlice";
import factorySalesForceReducer from "./factorySalesForce/factorySalesForceSlice";
import workerServiceReducer from "./workerServiceStatus/workerServiceSlice"
import interactionsReducer from "./interactions/interactionsSlice";
import usersReducer from "./users/usersSlice";
import taxonomiesAdminReducer from "./taxonomyAdmin/taxonomyAdminSlice";
import taxonomiesDescriptionReducer from "./taxonomyDescriptions/taxonomyDescriptionsSlice";
import rolesReducer from "./roles/rolesSlice";
import exceptionReducer from "./exceptions/exceptionsSlide"
import workshopAdminReducer from "./workshopsAdmin/workshopAdminSlice";
import campaignReducer from "./campaigns/campaignSlice";
import mailMapperReducer from "./mailMappers/mailMappersSlide"
import brandReducer from "./brands/brandSlice"
import modelReducer from "./models/modelSlice"

export default configureStore({
    reducer: {
      workshops: workshopsReducer,
      authentication: authenticationReducer,
      cases: casesReducer,
      calls: callsReducer,
      modal: modalReducer,
      contract: contractReducer,
      vehicles:vehiclesReducer,
      itvs:itvsReducer,
      customers:customersReducer,
      taxonomies: taxonomiesReducer,
      caseStates: caseStatesReducer,
      appState: appStateReducer,
      templates: templatesReducer,
      provinces: provincesReducer,
      documentationTemplate: documentationTemplatesReducer,
      workshopAppointmentTemplates: workshopAppointmentTemplatesReducer,
      workshopSearch: workshopSearchReducer,
      entryChannels : entryChannelsReducer,
      worshopTypes : worshopTypesReducer,
      actionResolutions : ActionResolutionsReducer,
      currentCase : currentCaseReducer,
      documentationRequestTemplates:documentationRequestTemplatesReducer,
      taxonomyTemplates: taxonomyTemplates,
      factoryCases: factoryCasesReducer,
      factoryProvinces: factoryProvincesReducer,
      factoryCities: factoryCitiesReducer,
      factoryOffices: factoryOfficesReducer,
      factoryRentTypes: factoryRentTypesReducer,
      factoryChannels: factoryChannelsReducer,
      factoryCategories: factoryCategoriesReducer,
      factoryTypes: factoryTypesReducer,
      factoryRates: factoryRatesReducer,
      factoryBranches: factoryBranchesReducer,
      factoryITVBond: factoryITVBondReducer,
      caseForms: caseFormsReducer,
      factoryBagGroups: factoryBagGroupsReducer,
      factorySalesForce: factorySalesForceReducer,
      workerService: workerServiceReducer,
      interactions : interactionsReducer,
      users: usersReducer,
      taxonomyAdmin: taxonomiesAdminReducer,
      taxonomyDescriptions: taxonomiesDescriptionReducer,
      roles: rolesReducer,
      exceptions: exceptionReducer,
      workshopsAdmin : workshopAdminReducer,
      campaigns : campaignReducer,
      mailMappers : mailMapperReducer,
      brands : brandReducer,
      models : modelReducer
    },
  });